import { GlobalStyles as MuiGlobalStyles } from '@mui/material';
import { Palette } from './themeOverrides/Palette';
import { filterStyles } from '@/themes/commonStyles/filterStyles.js';
import { breakpoints } from '@/themes/themeOverrides/Breakpoints';

export const GlobalStyles = () => (
    <MuiGlobalStyles
        styles={{
            ...filterStyles,
            body: {
                backgroundColor: Palette.gray.gray75,
            },
            '::-moz-selection': {
                color: Palette.black,
                background: Palette.yellow.yellow200,
            },
            '::selection': {
                color: Palette.black,
                background: Palette.yellow.yellow200,
            },
            '::-webkit-scrollbar': {
                width: '8px',
                height: '8px',
            },
            '::-webkit-scrollbar-track': {
                background: Palette.white,
            },
            '::-webkit-scrollbar-thumb': {
                background: Palette.gray.gray200,
                borderRadius: '4px',
                '&:hover': {
                    background: Palette.gray.gray300,
                },
            },
            '#main-content': {
                padding: '0',
                flex: '1',
            },
            '.more-content': {
                padding: '8px',
                '& button': {
                    fontWeight: '400',
                },
            },
            '.gray-text': {
                color: Palette.gray.gray500,
            },
            '.modal-toolbar': {
                display: 'flex',
                justifyContent: 'space-between',
            },
            '.page-title.MuiTypography-h3 span.RaConfigurable-root + span.RaConfigurable-root': {
                display: 'none',
            },
            'html.noscroll': {
                overflow: 'hidden',
                position: 'fixed',
                left: '0',
                right: 'var(--scrollbar-compensation, 0px)',
                width: 'auto',
                height: '100%',
            },
            'body.noscroll': {
                overflow: 'hidden',
                position: 'fixed',
                left: '0',
                right: 'var(--scrollbar-compensation, 0px)',
                width: 'auto',
                '& #main-content .MuiTablePagination-root.pagination-scroll-locked': {
                    [`@media (min-width: ${breakpoints.values.lg}px)`]: {
                        position: 'fixed',
                        top: 'var(--pagination-lock-top)',
                        left: 'var(--pagination-lock-left)',
                        width: 'var(--pagination-lock-width)',
                        bottom: 'auto',
                        right: 'auto',
                    },
                },
            },
            '.wrapper.noscroll, .RaLayout-content.noscroll, #main-content.noscroll, .scroll-container.noscroll, .RaDatagrid-tableWrapper.noscroll': {
                overflow: 'hidden !important',
                overscrollBehavior: 'none',
            },
        }}
    />
);
